import { Book } from "../../shared/book.model";
import { Component, OnInit } from "@angular/core";
import { Router, ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";
import { BookService } from "src/app/shared/book.service";
declare var $: any;
interface IWindow extends Window {
	webkitSpeechRecognition: any;
	SpeechRecognition: any;
}

declare let alertify: any;
declare let localforage: any;
declare let window: any;

@Component({
	selector: "app-book-detail",
	templateUrl: "./book-detail.component.html",
	styleUrls: ["./book-detail.component.scss"],
})
export class BookDetailComponent implements OnInit {
	listBook!: any[];
	bookCode!: Book;
	listBiletKeyWords!: any[];
	filterBiletKeyWords: Book[] = [];
	showSearchButton!: boolean;
	speechData!: string;
	text!: string;
	p: number = 1;
	urlImage!: string;
	urlImage2!: string;
	paramsObject: any;
	code: string = '';
	id: string = '';
	keyword1: string = '';
	keyword2: string = '';

	pageCurrent: number = 1;

	totalSlide: number = 0;

	constructor(
		private route: ActivatedRoute,
		private service: BookService,
		private location: Location, private router: Router,
		private activatedRoute: ActivatedRoute
	) {
	}

	ngOnInit(): void {
		document.body.className = 'bl-page-book-detail';
		if (document.body.offsetWidth < 760) document.body.className = 'bl-view-mobile bl-page-book-detail';

		this.handleParams();
		this.getBookDetailFromRouter();

		window.__BookDetailComponent = this;
		document.onkeydown = this.checkKey;
	}

	checkKey(e: any) {
		e = e || window.event;
		const self = window.__BookDetailComponent;
		if (e.keyCode === 38) {
			// up arrow
			if (self.pageCurrent < self.totalSlide) self.pageCurrent++;
		}
		else if (e.keyCode === 40) {
			// down arrow
			if (self.pageCurrent > 1) self.pageCurrent--;
		}
		else if (e.keyCode === 37) {
			// left arrow
			if (self.pageCurrent > 1) self.pageCurrent--;
		}
		else if (e.keyCode === 39) {
			console.log(self.pageCurrent, self.totalSlide);
			// right arrow
			if (self.pageCurrent < self.totalSlide) self.pageCurrent++;
		}
	}

	test() {
		this.pageCurrent = 3;
	}

	getClassName() {
		return 'row book-detail p-0 p-md-3' + (document.body.offsetWidth < 760 ? ' bl-com-mobile' : '');
	}

	handleParams() {
		this.activatedRoute.queryParamMap.subscribe(it => {
			this.paramsObject = { ...it };
			this.code = this.paramsObject.params.code;
			this.id = this.paramsObject.params.id;
			this.keyword1 = this.paramsObject.params.keyword1;
			this.keyword2 = this.paramsObject.params.keyword2;
		});
	}

	pageChange(pageNumber: number) {
		//this.pageCurrent = pageNumber;
		console.log(`pageChange:`, this.pageCurrent);

		//var url = this.router.url.split("/")[1];
		//this.router.navigate(['main/book-detail'], { queryParams: { code: this.code, id: this.id } });
	}

	getBookDetailFromRouter(): void {
		var url = this.router.url.split("/")[1];
		// const id = this.route.snapshot.paramMap.get("id");
		// const code = this.route.snapshot.paramMap.get("code");
		var booksOnline = this.service.getBooks();
		var products: any = (booksOnline as any).default;
		var listItem = [];
		const keys = Object.keys(products);
		for (const property in products) {
			listItem.push(products[property]);
		}
		this.listBook = listItem.map((item, index) => {
			var biletkeyword = item.biletkeywords;
			var keyword1: string;
			var keyword2: string;
			var book: string;
			var category: string;
			biletkeyword.forEach((it: any, idx: number) => {
				keyword1 = it.keyword1.keyword_en;
				keyword2 = it.keyword2.keyword_en;
				book = item.code;
				category = it.category;
				this.urlImage = this.imageProcessKeyword(
					keyword1,
					book + "/image/" + category + "/"
				);
				this.urlImage2 = this.imageProcessKeyword(
					keyword2,
					book + "/image/" + category + "/"
				);
				it.keyword1.urlKeyword1 = this.urlImage;
				it.keyword2.urlKeyword2 = this.urlImage2;
			});
			item.biletcategory.forEach((o: any, idx: number) => {
				var urlIm = this.imageProcessKeyword(o.id, book + "/image/");
				item.biletcategory[idx].url = urlIm;
				item.biletcategory[
					idx
				].background = window.__static + `/static/${item.code}/image/background_stretch.png`;
			});

			return {
				...item,
				biletcategory: item.biletcategory,
			};
		});

		this.listBook.find((i) => {
			if (i.code == this.code) {
				this.bookCode = i;
				return this.bookCode;
			}
			return;
		});
		this.listBiletKeyWords = this.bookCode.biletkeywords.map((o) => {
			if (o.category === this.id) {
				return o;
			}
		});
		this.filterBiletKeyWords = this.listBiletKeyWords.filter(function(el) {
			return el != null;
		});
		if (this.keyword1 && this.keyword2) {
			console.log(this.filterBiletKeyWords);

		}
		if (url === "demo") {
			if (this.filterBiletKeyWords.length > 10) {
				this.filterBiletKeyWords = this.filterBiletKeyWords.slice(0, 10);
			}
		}

		this.totalSlide = this.filterBiletKeyWords.length;
	}

	imageProcessKeyword(filename: string, sourcefolder: string) {
		var lowerfilename = filename;
		lowerfilename = lowerfilename.toLocaleLowerCase();

		var newfilename = lowerfilename;
		if (newfilename.indexOf(" ") >= 0) {
			newfilename = newfilename.replace(/ /g, "_");
		} else if (filename.indexOf("/") >= 0) {
			newfilename = filename.replace("/", "-");
		} else if (filename.indexOf("'") >= 0) {
			newfilename = filename.replace("'", "_");
		}
		var url = window.__static + `/static/${sourcefolder}${newfilename}.png`;
		return url;
	}

	goBack(): void {
		this.location.back();
	}
}
